<div class="modal-header">
  <h3>
    {{
      PrimaryTradeLicenseRequirement && PrimaryTradeLicenseRequirement.id
        ? 'Edit'
        : 'Add'
    }}
    Trade Requirement
  </h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close('Cross Click')"
  ></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col">
      <form [formGroup]="primaryTradeLicenseForm">
        <div class="row g-3 align-items-center">
          <div class="col-6">
            <div class="form-group">
              <label for="tradeName" class="form-label" requiredAsterisk
                >Trade Name</label
              >

              @if (
                !PrimaryTradeLicenseRequirement ||
                !PrimaryTradeLicenseRequirement.id
              ) {
                <app-trade-selection-dropdown
                  (tradeSelectionEvent)="handleTradeSelection($event)"
                ></app-trade-selection-dropdown>
              }

              @if (
                PrimaryTradeLicenseRequirement &&
                PrimaryTradeLicenseRequirement.id
              ) {
                <select
                  id="tradeName"
                  class="form-select"
                  formControlName="PrimaryTradeId"
                >
                  <option [ngValue]="null" selected disabled>
                    Pick one...
                  </option>
                  @for (trade of trades; track trade) {
                    <option [ngValue]="trade.id">
                      {{ trade.name }}
                    </option>
                  }
                </select>
              }
            </div>
          </div>

          <div class="col-6">
            <div class="form-group">
              <label for="tradeStates" class="form-label" requiredAsterisk
                >Trade State / Province / Territory</label
              >
              <div
                id="tradeStates"
                ngbDropdown
                [autoClose]="'outside'"
                [ngClass]="{
                  'disabled-dropdown': $safeNavigationMigration(
                    PrimaryTradeLicenseRequirement?.id
                  )
                }"
              >
                <div class="input-group">
                  <div
                    class="form-control dropdown-toggle-override"
                    ngbDropdownToggle
                  >
                    <span class="icon-container"
                      ><i class="bi bi-chevron-down chevron-icon pull-right"></i
                    ></span>
                    @if (selectedSubNationalDivisions.length === 0) {
                      <span>Pick one or multiple...</span>
                    }
                    @if (selectedSubNationalDivisions.length > 0) {
                      @for (snd of selectedSubNationalDivisions; track snd) {
                        <span
                          class="badge bg-primary mx-1 badge-margin"
                          contenteditable="false"
                          (click)="onBadgeClick($event)"
                          >{{ snd.abbreviation }}
                          <i
                            class="bi bi-x-lg cursor-select"
                            (click)="selectionChange($event, snd)"
                          ></i
                        ></span>
                      }
                    }
                  </div>
                </div>

                <div ngbDropdownMenu>
                  <div class="form-check mx-3">
                    <label
                      for="selectAllSND"
                      class="form-check-label cursor-select"
                      >{{
                        selectAllSubNationalDivisions ? 'De-select' : 'Select'
                      }}
                      All</label
                    >
                    <input
                      id="selectAllSND"
                      type="checkbox"
                      class="form-check-input cursor-select"
                      [checked]="selectAllSubNationalDivisions"
                      (change)="selectAll()"
                    />
                  </div>
                  <hr class="m-0 mb-1" />
                  <ul class="list-unstyled scrollable-dropdown mb-0">
                    @for (snd of subNationalDivisions; track snd) {
                      <ng-container class="">
                        @if (snd) {
                          <li class="px-3">
                            <div class="form-check">
                              <label
                                for="subNationalDivision-{{ snd.abbreviation }}"
                                class="form-check-label cursor-select"
                                >{{ snd.name }}</label
                              >
                              <input
                                id="subNationalDivision-{{ snd.abbreviation }}"
                                type="checkbox"
                                class="form-check-input cursor-select"
                                [checked]="
                                  selectedSubNationalDivisions.includes(snd)
                                "
                                (change)="selectionChange($event, snd)"
                              />
                            </div>
                          </li>
                        }
                      </ng-container>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>

          @if (selectedSubNationalDivisions.length < 2) {
            <div class="col-4">
              <div class="form-group">
                <label for="tradeCity" class="form-label">City</label>
                <input
                  id="tradeCity"
                  type="text"
                  class="form-control"
                  formControlName="city"
                />
              </div>
            </div>
          }

          <div class="col-4">
            <div class="form-group">
              <label for="lookupURL" class="form-label">Lookup URL</label>
              <input
                id="lookupURL"
                type="text"
                class="form-control"
                formControlName="lookupURL"
              />
            </div>
          </div>

          <div class="col-4">
            <div class="form-check-group">
              <label for="isRequired" class="form-check-label"
                >Requires a License?</label
              >
              <input
                id="isRequired"
                type="checkbox"
                class="form-check-input"
                formControlName="isRequired"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="row w-100 justify-content-end">
    <div class="col-3">
      <button class="btn btn-danger" (click)="close('Close')">Close</button>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>
</div>
